import * as React from "react";
import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Slide,
  TextField,
  Theme,
  withStyles,
  Tooltip,
  InputLabel,
  Select,
  MenuItem,
  FormControl,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import { API } from "aws-amplify";
import { TransitionProps } from "@material-ui/core/transitions";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import ProfileResult from "./ProfileResult";
import { Alert } from "@material-ui/lab";

const styles = ({ spacing }: Theme) =>
  createStyles({
    buttonWrapper: {
      backgroundColor: "#00cc00",
      marginTop: spacing(1),
    },
  });

interface IProfileState {
  actorSubType: string;
  caregiverPersonId: string;
  commonAllergies: any;
  commonHealthConditions: any;
  customerId: any;
  customerJourneyType: string;
  dateOfBirth: string;
  enrollToPharmacy: boolean;
  formSubmitted: boolean;
  gender: string;
  identityValidationStatus: string;
  insurancePlan: string;
  legalFirstName: string;
  legalLastName: string;
  medicationOrVitaminName: string;
  message: string;
  middleName: string;
  open: boolean;
  passcode: string;
  pregnantOrNursing: string;
  profileName: string;
  programName: string;
  residentialAddressId: string;
  resultSuccessful: boolean;
  showCaregiverPersonId: boolean;
  showLoadingSpinner: boolean;
  showSignUp: boolean;
  signUp: boolean;
  spi: string;
  ssn: string;
  suffix: string;
  source: string;
  response: string;
}

const TransitionConst = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement<any, any> },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class ProfileSection extends React.Component<any, IProfileState> {
  constructor(props: any) {
    super(props);
    this.state = {
      actorSubType: "",
      caregiverPersonId: "",
      commonAllergies: ["5662329769702d0523000000"],
      commonHealthConditions: ["53504d460937fe33aa001366"],
      customerId: "",
      customerJourneyType: "",
      dateOfBirth: "",
      enrollToPharmacy: true,
      formSubmitted: false,
      gender: "Female",
      identityValidationStatus: "",
      insurancePlan: "Continue Without Insurance",
      legalFirstName: "Jane",
      legalLastName: "Doe",
      medicationOrVitaminName: "5dfe9153bb9b761cd3568361",
      message: "",
      middleName: "",
      open: false,
      passcode: "1111",
      pregnantOrNursing: "Yes",
      profileName: "",
      programName: "WOLFGANG",
      residentialAddressId:
        "PRKOYXYXW3JPS5HB47REG13RMRDE8G5NZWAWZN5G8EDRMRIPXTQ2EIA2OXVB6IP2",
      response: "",
      resultSuccessful: false,
      showCaregiverPersonId: false,
      showLoadingSpinner: false,
      showSignUp: false,
      signUp: true,
      source: "MANUAL",
      spi: "1013626948011",
      ssn: "1234",
      suffix: "",
    };

    this.handleActorSubType = this.handleActorSubType.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleProfileName = this.handleProfileName.bind(this);
    this.handleCustomerId = this.handleCustomerId.bind(this);
    this.handleEnrollToPharmacy = this.handleEnrollToPharmacy.bind(this);
    this.handleSignUp = this.handleSignUp.bind(this);
    this.handleCaregiverId = this.handleCaregiverId.bind(this);
  }

  public render() {
    // @ts-ignore
    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          {this.state.showLoadingSpinner && <LoadingSpinner />}

          <Alert severity="info">
            <p>1. Make sure there is no duplicated profile name exists.</p>
            <p>2. Sign Up flow will go through with default profile contents</p>
            <p>
              3. If you only want to create an Amazon profile and not enroll to
              a pharmacy,
              <br />
              &nbsp;&nbsp;&nbsp;&nbsp;uncheck "Enroll to a pharmacy?" checkbox
            </p>
          </Alert>

          <Grid item xs>
            <FormControl component="fieldset">
              <FormGroup style={{ width: 225 }}>
                <FormControlLabel
                  control={<Checkbox checked={this.state.enrollToPharmacy} />}
                  label="Enroll to a pharmacy?"
                  onChange={this.handleEnrollToPharmacy}
                />
              </FormGroup>
            </FormControl>
          </Grid>

          <Grid item xs>
            <FormControl>
              <InputLabel>ActorSubType (Required)</InputLabel>
              <Select
                value={this.state.actorSubType}
                style={{ width: 225 }}
                onChange={this.handleActorSubType}
              >
                <MenuItem value="ADULT">
                  <em>ADULT</em>
                </MenuItem>
                <MenuItem value="CHILD">
                  <em>CHILD</em>
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs>
            <TextField
              style={{ width: 225 }}
              label="Customer Id (Required)"
              helperText={this.state.showCaregiverPersonId
                ? "Account to create the profile under (primary caregiver's customerId for a CHILD)"
                : undefined}
              variant="outlined"
              value={this.state.customerId}
              onChange={this.handleCustomerId}
            />
          </Grid>

          <Grid item xs>
            <Tooltip
              disableFocusListener
              title="Please make sure there is no duplicated profile name exists."
            >
              <TextField
                style={{ width: 225 }}
                label="Profile Name (Required)"
                variant="outlined"
                value={this.state.profileName}
                onChange={this.handleProfileName}
              />
            </Tooltip>
          </Grid>

          {this.state.showSignUp && (
            <Grid item xs>
              <FormControl component="fieldset">
                <FormGroup style={{ width: 225 }}>
                  <FormControlLabel
                    control={<Checkbox checked={this.state.signUp} />}
                    label="Go through signup?"
                    onChange={this.handleSignUp}
                  />
                </FormGroup>
              </FormControl>
            </Grid>
          )}

          {this.state.showCaregiverPersonId && (
            <Grid item xs>
              <TextField
                style={{ width: 225 }}
                label="Caregiver Id (Required)"
                helperText="Primary caregiver's personId"
                variant="outlined"
                value={this.state.caregiverPersonId}
                onChange={this.handleCaregiverId}
              />
            </Grid>
          )}

          <Grid item xs>
            <Button
              variant="outlined"
              color="default"
              onClick={this.handleSubmit}
            >
              Submit
            </Button>
          </Grid>

          <Grid item xs={12}>
            {this.state.formSubmitted && <LoadingSpinner />}
            {this.state.resultSuccessful && (
              <ProfileResult
                resultSuccessful={this.state.resultSuccessful}
                response={this.state.response}
              />
            )}
          </Grid>

          {this.state.message && (
            <Dialog
              open={this.state.open}
              TransitionComponent={TransitionConst}
              keepMounted
              aria-labelledby="alert-dialog-slide-title"
              aria-describedby="alert-dialog-slide-description"
              onClose={this.handleClose}
            >
              <DialogTitle id="alert-dialog-slide-title">
                {"Exception occurred when adding a profile"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  {this.state.message}
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          )}
        </Grid>
      </Grid>
    );
  }

  public handleClose() {
    this.setState({ open: false });
  }

  public handleActorSubType(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ actorSubType: event.target.value });
    if (event.target.value === "ADULT") {
      this.setState({ customerJourneyType: "sign-up-for-self" });
      this.setState({ dateOfBirth: "1980-10-10" });
      if (this.state.enrollToPharmacy === true) {
        this.setState({ showSignUp: true });
        this.setState({ showCaregiverPersonId: false });
      } else {
        this.setState({ showSignUp: false });
        this.setState({ showCaregiverPersonId: false });
      }
    } else if (event.target.value === "CHILD") {
      this.setState({ customerJourneyType: "add-dependent" });
      this.setState({ dateOfBirth: "2020-10-10" });
      this.setState({ signUp: true });
      if (this.state.enrollToPharmacy === true) {
        this.setState({ showSignUp: false });
        this.setState({ showCaregiverPersonId: true });
      } else {
        this.setState({ showSignUp: false });
        this.setState({ showCaregiverPersonId: false });
      }
    }
  }

  public handleCustomerId(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ customerId: event.target.value });
  }

  public handleProfileName(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ profileName: event.target.value });
  }

  public handleSignUp(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.checked) {
      this.setState({ signUp: true });
    } else {
      this.setState({ signUp: false });
    }
  }

  public handleEnrollToPharmacy(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.checked) {
      this.setState({ enrollToPharmacy: true });
      if (this.state.actorSubType === "ADULT") {
        this.setState({ showSignUp: true });
        this.setState({ showCaregiverPersonId: false });
      } else if (this.state.actorSubType === "CHILD") {
        this.setState({ showSignUp: false });
        this.setState({ showCaregiverPersonId: true });
      }
    } else {
      this.setState({ enrollToPharmacy: false });
      this.setState({ showSignUp: false });
      this.setState({ showCaregiverPersonId: false });
    }
  }

  private handleValidation() {
    let formIsValid = true;
    if (!this.state.customerId) {
      alert("Please enter a customer id");
      formIsValid = false;
    } else if (!this.state.customerId.match("^A[A-Z0-9]*$")) {
      alert("Please enter a valid customer id.");
      formIsValid = false;
    }
    if (!this.state.actorSubType) {
      alert("Please enter an ActorSubType");
      formIsValid = false;
    } else if (!this.state.actorSubType.match("^ADULT|CHILD$")) {
      alert("Please enter a valid ActorSubType.");
      formIsValid = false;
    }
    if (!this.state.profileName) {
      alert("Please enter a profile name");
      formIsValid = false;
    } else if (!this.state.profileName.match("^[\\w\\s]+$")) {
      alert("Please enter a valid profile name.");
      formIsValid = false;
    }
    return formIsValid;
  }

  private handleCaregiverId(event: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ caregiverPersonId: event.target.value });
    this.setState({ signUp: true });
  }

  private handleSubmit() {
    if (this.handleValidation()) {
      this.setState({ formSubmitted: true });
      this.setState({ resultSuccessful: false });

      const apiName = "ApaqPortalAPI";
      const path = "/pharmacy-customer/update/add-profile";
      const config = {
        body: {
          actorSubType: this.state.actorSubType,
          caregiverPersonId: this.state.caregiverPersonId,
          commonAllergies: this.state.commonAllergies,
          commonHealthConditions: this.state.commonHealthConditions,
          customerId: this.state.customerId,
          customerJourneyType: this.state.customerJourneyType,
          dateOfBirth: this.state.dateOfBirth,
          enrollToPharmacy: this.state.enrollToPharmacy,
          gender: this.state.gender,
          identityValidationStatus: this.state.identityValidationStatus,
          insurancePlan: this.state.insurancePlan,
          legalFirstName: this.state.legalFirstName,
          legalLastName: this.state.legalLastName,
          medicationOrVitaminName: this.state.medicationOrVitaminName,
          middleName: this.state.middleName,
          name: this.state.profileName,
          passcode: this.state.passcode,
          pregnantOrNursing: this.state.pregnantOrNursing,
          programName: this.state.programName,
          residentialAddressId: this.state.residentialAddressId,
          signUp: this.state.signUp,
          source: this.state.source,
          spi: this.state.spi,
          ssn: this.state.ssn,
          suffix: this.state.suffix,
        },
        headers: {},
      };

      API.post(apiName, path, config)
        .then((response) => {
          console.log(response);
          this.setState({ resultSuccessful: true });
          this.setState({ formSubmitted: false });
          this.setState({
            response:
              "Adding a profile was Successful" +
              "\n" +
              '{ "Person ID":"' +
              response.personId +
              '" }' +
              "\n" +
              '{ "Phone Number":"' +
              response.phoneNumber +
              '" }',
          });
        })
        .catch((error) => {
          console.log(error);
          this.setState({ open: true });
          this.setState({ formSubmitted: false });
          this.setState({ message: error.response.data.message });
        });
    }
  }
}

export default withStyles(styles)(ProfileSection);
